module.exports = __webpack_public_path__ + "static/img/camera.4ca95a29.svg";